// Types
import Vue from"vue";// Components
const ForgotPasswordView=Vue.extend({name:"ForgotPasswordView",render(){const a=arguments[0];return a("div",["Forgot password?"])}});export default ForgotPasswordView;